"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth0ProviderWithNavigate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const auth0_react_1 = require("@auth0/auth0-react");
const react_router_dom_1 = require("react-router-dom");
const Auth0ProviderWithNavigate = ({ children, }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const onRedirectCallback = (appState) => {
        navigate(appState?.returnTo || window.location.pathname);
    };
    return ((0, jsx_runtime_1.jsx)(auth0_react_1.Auth0Provider, { domain: "ahticlimate.eu.auth0.com", clientId: "scPIVPmi02FXh3lJDSqdWZ2nY8JK9uTc", authorizationParams: {
            redirect_uri: window.location.origin,
            scope: "openid profile email roles offline_access",
            audience: "https://api.ahticlimate.com/v1/",
        }, onRedirectCallback: onRedirectCallback, cacheLocation: "localstorage", useRefreshTokens: true, children: children }));
};
exports.Auth0ProviderWithNavigate = Auth0ProviderWithNavigate;
